/* eslint-disable prefer-rest-params */
// import * as APIS from './Apis';

import { moment } from '@icedesign/base';

import { isWMSdk, getSystemCode, isAdvancedTask, isMulti, getProfile } from '@/tool/profile';
import { uniqueObjectArray } from '@/tool/tool';

import * as hmAPIs from './HM/Apis';
import * as wmAPIs from './WM/Apis';

// 作为过渡层，居然直接这么写就好了？？？
// export * from './HM/Apis';

export const connect = () => {
  const connect = isWMSdk() ? wmAPIs.connect : hmAPIs.connect;
  return connect();
};

export const stopReconnect = () => {
  return (isWMSdk() ? wmAPIs.stopReconnect : hmAPIs.stopReconnect)();
};

export const registerSdk = () => {
  // return (isWMSdk() ? wmAPIs.initSdk : hmAPIs.registerSdk)();

  return (isWMSdk() ? wmAPIs.initSdk : hmAPIs.registerSdk)(getSystemCode());
};

export const releaseSdk = () => {
  return (isWMSdk() ? wmAPIs.releaseSdk : hmAPIs.releaseSdk)();
};

export const disconnect = () => {
  return (isWMSdk() ? wmAPIs.disconnect : hmAPIs.disconnect)();
};

export const setKeySecret = () => {
  return (isWMSdk() ? wmAPIs.setKeySecret : hmAPIs.registerKey)();
};

export const clearKeySecret = () => {
  return (isWMSdk() ? wmAPIs.clearKeySecret : hmAPIs.logoutKey)();
};

export function readKey() {
  // 这里统一处理封装返回数据格式，主要是为了照顾KeyEdit的读取钥匙信息组成钥匙模板时判断不那么复杂，和统一黑名单标志为blacklistFlag
  // 副作用是可能会产生一些副作用，比如同时存在blacklistFlag和blacklistflag属性，仍然保留了各种type/mode等容易混淆的概念，在KeyConnector中钥匙状态显示比较混乱
  // return new Promise((resolve, reject) => {
  //     (isWMSdk() ? wmAPIs.readKeyInfo : hmAPIs.readKey)().then(data => resolve({
  //         ...data,
  //         //HM下需要手动生成锁号，所以这里强制为空，而WM就是使用id作为锁号
  //         keyno: isWMSdk() ? data.id : '',
  //         // 已知华门类型：NFC:"RCLB-KEY V3.0.1" BLE："B03018V206"
  //         keytype: isWMSdk() ? data.type : (data.version && !data.version.includes('RCLB-KEY') ? 1 : 0),
  //         //blacklistFlag: isWMSdk() ? data.blacklistFlag : data.blacklistflag,

  //     }))
  // }, err => reject(err))
  return (isWMSdk() ? wmAPIs.readKeyInfo : hmAPIs.readKey)(...arguments);
}

export const readKeyExperimental = () => {
  return new Promise((resolve, reject) => {
    (isWMSdk() ? wmAPIs.readKeyInfo : hmAPIs.readKey)().then(
      data =>
        resolve({
          ...data,
          // 已知华门类型：NFC:"RCLB-KEY V3.0.1" BLE："B03018V206"
          time: isWMSdk()
            ? data.time
            : moment(data.time, 'YYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'),
          keytype: isWMSdk()
            ? data.type
            : data.version && !data.version.includes('RCLB-KEY')
            ? 1
            : 0,
          // blacklistFlag: isWMSdk() ? data.blacklistFlag : data.blacklistflag,
        }),
      err => reject(err)
    );
  });
};

export const readKeyInfoEx = () => {
  return new Promise((resolve, reject) => {
    wmAPIs.readKeyInfoEx().then(
      data =>
        resolve({
          ...data,
          // 已知华门类型：NFC:"RCLB-KEY V3.0.1" BLE："B03018V206"
          time: isWMSdk()
            ? data.time
            : moment(data.time, 'YYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'),
          keytype: isWMSdk()
            ? data.type
            : data.version && !data.version.includes('RCLB-KEY')
            ? 1
            : 0,
          // blacklistFlag: isWMSdk() ? data.blacklistFlag : data.blacklistflag,
        }),
      err => reject(err)
    );
  });
};

// TODO: 暂时没有用到，将其拆解成了下方的两个方法
export function readKeyEvent() {
  return (isWMSdk() ? wmAPIs.readKeyRecords : hmAPIs.readKeyEvent)(...arguments);
}

export function readUnlockRecords() {
  return new Promise((resolve, reject) => {
    (isWMSdk() ? wmAPIs.readKeyRecords : hmAPIs.readKeyEvent)(...arguments).then(
      data => {
        let unlockEvents;
        if (isWMSdk()) {
          // WM:mode=10代表是开关锁钥匙下的开关锁记录mode=9代表是应急钥匙下的开关锁记录，flag代表成功失败信息，status 0开锁1开锁
          // cmd=1物理应急钥匙
          // 2026-08-01 LQ 增加cmd == 19 采集锁锁号类型数据
          // 单企业开启巡检功能，或是多企业开启巡检功能且当前企业开启巡检功能
          const patrol =
            getProfile().patrol && (!isMulti() || (isMulti() && getProfile().companypatrol));
          unlockEvents = data.records
            ? data.records.filter(
                item =>
                  item.cmd == 10 ||
                  item.cmd == 9 ||
                  item.cmd == 1 ||
                  item.isevent === 1 ||
                  (item.cmd == 19 && patrol)
              )
            : [];
        } else {
          // HM:其中1是成功，4-6，8是各种原因造成的开锁失败;
          unlockEvents = data.eventlist
            ? data.eventlist.filter(item => [1, 4, 5, 6, 8].includes(item.type))
            : [];
        }
        console.log('unlockEvents', unlockEvents);
        const unifiedResult = unlockEvents.map(item => ({
          flag1: item.flag1,
          origstatus: item.status,
          cmd: item.cmd,
          isevent: item.isevent,
          // WM下data.keyid应该是肯定存在的
          // Upgrade 2022.10.24 为了支持事件钥匙读取数据支持显示正确的keyid，每条记录加了了是否是事件的标志isevent，并加入了keyid属性；
          // 目前新版钥匙读取记录已经全部在内层加入keyid，保留原本的外层data.keyid主要是为了兼容旧设备；
          keyid: isWMSdk() ? (item.isevent ? item.keyid : data.keyid || 'unknown') : item.userid,
          lockid: item.lockid,
          time: isWMSdk()
            ? item.time
            : moment(item.time, 'YYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'),
          // HM开锁成功事件和失败状态保存在type里，而WM各种状态（成功=0，失败>0保存在flag）开关锁状态保存在status（status 0开锁1关锁）
          // 考虑到HM、WM、后台接口的兼容性，这里把华门普通钥匙的开锁事件由1强制转换为0,
          // TODO: type命名稍微有点不科学
          // type: isWMSdk() ? item.flag : (item.type === 1 ? 0 : item.type),
          // 由于被识别为黑名单而开锁失败的事件，HM为8，WM为255，这里统一修正为255
          // item.flag：0-开锁成功，1-关锁成功，13-蓝牙开锁成功(HM)，14-蓝牙关锁成功(HM)，防火门右开：128开锁成功, 129关锁成功，防火门左开：144开锁成功, 145关锁成功；
          type: isWMSdk() ? item.flag : item.type === 1 ? 0 : item.type == 8 ? 255 : item.type,

          // status：0-开锁，1-关锁
          status: isWMSdk()
            ? // WM返回的status是尝试开关锁操作后的锁的状态，而业务逻辑需要的操作的动作，所以在操作失败后，取当前锁的状态的反状态即可
              // 2023-10-27添加了防火门锁规则：左开: flag=144 开, flag=145 关；右开: flag=128 开,  flag=129 关
              // TODO: 如此操作会不会有其他风险？
              // TODO: 后期再约定具体的接口返回逻辑

              // 添加防火门锁前
              // (item.status + ((item.flag == 0 || item.flag == 1) ? 0 : 1)) % 2

              // 添加防火门锁后
              // 2023-10-27添加了防火门锁：左开: flag=144 开, flag=145 关；右开: flag=128 开,  flag=129 关
              (item.status +
                (item.flag == 0 ||
                item.flag == 1 ||
                item.flag == 128 ||
                item.flag == 129 ||
                item.flag == 144 ||
                item.flag == 145
                  ? 0
                  : 1)) %
              2
            : // HM普通钥匙模式下，仅有开锁事件
              0,
          // TODO: 这个属性对于非WM指纹钥匙可能有些多余，可以根据条件进行二次合并
          fingerid: isWMSdk() ? item.finger : null,

          // TODO: 多任务模式专用属性
          // 由于是否是高级模式需要根据连接的钥匙判断，所以这里仅判断是否是任务模式
          userids: isAdvancedTask() ? item.userids : null,
          // taskid: isAdvancedTask() ? item.taskid : null,
          taskid: item.taskid || null,

          // TODO: 不如索性把剩余的，未进行其他格式化的属性都一股脑返回吧？？？
        }));
        resolve(unifiedResult);
      },
      err => reject(err)
    );
  });
}

export function readCollectedLockIds() {
  return new Promise((resove, reject) => {
    (isWMSdk() ? wmAPIs.readKeyRecords : hmAPIs.readKey)(...arguments).then(
      data => {
        let collectedLockIds;
        if (isWMSdk()) {
          // 其中可能存在重复的锁号，这里使用Set过滤一下
          // collectedLockIds = [...new Set(data.records ?
          //     data.records.filter(
          //         item => item.cmd == 19 && item.flag !== 254 // 国内外不匹配时，返回的flag值为254，需要从读锁号结果中过滤一下
          //     ).map(item => ({
          //         id: item.lockid,
          //         flag: item.flag,
          //     }))
          //     :
          //     [])
          // ]
          // 去除重复内容
          collectedLockIds = data.records
            ? uniqueObjectArray(
                data.records.filter(
                  item => item.cmd == 19 && item.flag !== 254 && item.flag !== 67 // 67代表防串码不匹配
                ),
                'lockid'
              ).map(item => ({
                id: item.lockid,
                flag: item.flag,
              }))
            : [];
        } else {
          // TODO: HM的这个接口在替换锁 + 钥匙信息弹窗时用到了，采集锁没用
          collectedLockIds = [{ id: data.lockid }];
        }
        resove(collectedLockIds);
      },
      err => reject(err)
    );
  });
}

/**
 * 读取 USB 钥匙内巡检采集记录（cmd=19：锁号 + 采集时间，无内容与多媒体）。
 * WM 协议与 readKeyRecords 一致；HM 暂无对应采集指令，返回空数组。
 */
export function readPatrolCollectRecords(clearAfterRead = false) {
  return new Promise((resolve, reject) => {
    (isWMSdk() ? wmAPIs.readKeyRecords : hmAPIs.readKeyEvent)(clearAfterRead).then(
      data => {
        if (isWMSdk()) {
          const records = (data.records || [])
            .filter(item => item.cmd == 19 && item.flag !== 254 && item.flag !== 67)
            .map(item => ({
              lockno: String(item.lockid),
              patroltime: item.time,
            }));
          resolve(records);
        } else {
          resolve([]);
        }
      },
      err => reject(err)
    );
  });
}

export function clearKeyRecords() {
  // HM不提供直接清空的方法，所以调用读取并加入清空标志
  return (isWMSdk() ? wmAPIs.clearKeyRecords : hmAPIs.readKeyEvent)(true);
}

export function createBlankKey() {
  return (isWMSdk() ? wmAPIs.createBlankKey : hmAPIs.createBlankKey)(...arguments);
}

export function createUnlockKey() {
  return (isWMSdk() ? wmAPIs.createUnlockKey : hmAPIs.createUnlockKey)(...arguments);
}

// 2025-12-08 为了满足任务开始结束时间支持到时分秒的时间段的逻辑调整
export function createUnlockKeyForMultiTimeBlocks() {
  return (isWMSdk() ? wmAPIs.createUnlockKeyForMultiTimeBlocks : hmAPIs.createUnlockKey)(
    ...arguments
  );
}

export function createSetLockSecretKey() {
  return (isWMSdk() ? wmAPIs.createSetLockSecretKey : hmAPIs.createRegisterKey)(...arguments);
}

export function createClearLockSecretKey() {
  return (isWMSdk() ? wmAPIs.createClearLockSecretKey : hmAPIs.logoutKey)(...arguments);
}

// TODO: 重命名
// 修改锁的id和groupid，目前只有hm用到
export function createSettingKey() {
  return (isWMSdk() ? () => Promise.resolve() : hmAPIs.createSettingKey)(...arguments);
}

// 读取锁的id和groupid，hm才有groupid
export function createVerifyKey() {
  return (isWMSdk() ? wmAPIs.createReadLockNoKey : hmAPIs.createVerifyKey)(...arguments);
}

// 读取锁的硬件编号，目前只有hm用到
export function createTraceKey() {
  return (isWMSdk() ? () => Promise.resolve() : hmAPIs.createTraceKey)(...arguments);
}

// 读取锁内存储的开锁成功事件，目前只有hm用到
export function createAuditKey() {
  return (isWMSdk() ? wmAPIs.createReadLockEventKey : hmAPIs.createAuditKey)(...arguments);
}

// 万能钥匙，目前只有hm用到
export function createEmergencyKey() {
  return (isWMSdk() ? wmAPIs.createEmergencyKey : hmAPIs.createEmergencyKey)(...arguments);
}

// TODO: 考虑加入一个makeWhiteKey接口？
export function createBlacklistKey() {
  return (isWMSdk() ? wmAPIs.createBlacklistKey : hmAPIs.createBlacklistKey)(...arguments);
}

// 清除钥匙黑名单标记，
// TODO: 目前程序中使用的是hm的createBlankKey以清除黑名单标记
export function clearKeyBlacklistFlagAndResetBlank() {
  if (isWMSdk()) {
    return new Promise((resolve, reject) => {
      wmAPIs.clearKeyBlacklistFlag().then(
        () => {
          // TODO: 在后续的钥匙操作过程中，会有很多置空的操作，其实这里不写也是没什么问题的，为了逻辑的统一暂时写上
          wmAPIs.createBlankKey(true).then(
            () => {
              resolve();
            },
            err => reject(err)
          );
        },
        err => reject(err)
      );
    });
  }
  return hmAPIs.createBlankKey(...arguments);

  // return (isWMSdk() ? wmAPIs.clearKeyBlacklistFlag : hmAPIs.createBlankKey)(...arguments)
}

export function createCollectFingerprintKey() {
  return (isWMSdk() ? wmAPIs.createCollectFingerPrintKey : () => Promise.resolve())(...arguments);
}

export function isUnlockKey(key) {
  // WM mode = 19;
  // HM type = userkey;
  return key.mode === 10 || key.type === 'userkey';
}

export function startDynamicReadLockNoKey() {
  return (isWMSdk() ? wmAPIs.startDynamicReadLockNoKey : () => Promise.resolve())(...arguments);
}

export function stopDynamicReadLockNoKey() {
  return (isWMSdk() ? wmAPIs.stopDynamicReadLockNoKey : () => Promise.resolve())(...arguments);
}
// 设置音量
export function setKeyVolume() {
  return (isWMSdk() ? wmAPIs.setKeyVolume : () => Promise.resolve())(...arguments);
}
// 指纹授权方式和指纹时长
export function setFingerValidity() {
  return (isWMSdk() ? wmAPIs.setFingerValidity : () => Promise.resolve())(...arguments);
}
// 指纹授权方式和指纹时长
export function setAutoPowerOff() {
  return (isWMSdk() ? wmAPIs.setAutoPowerOff : () => Promise.resolve())(...arguments);
}
// 针对 772 以上版本钥匙，是否支持任务id
export function setKeyEnableTask() {
  return (isWMSdk() ? wmAPIs.setKeyEnableTask : () => Promise.resolve())(...arguments);
}
